import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IconService } from '@isophi/core-ui';
import { ChildProfileList, GenderEnum, MainContactInvitationStatusEnum } from '@isophi/mng-api';

import { MenuTypeEnum } from '../../../../core/enums/menu-type.enum';

@Component({
  selector: 'app-child-row',
  templateUrl: './child-row.component.html',
  styleUrls: ['./child-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChildRowComponent {
  @Input() child: ChildProfileList;
  @Input() isChildMarked: boolean;

  @Output() childClick = new EventEmitter<ChildProfileList>();
  @Output() refreshChildren = new EventEmitter<void>();

  public icons = inject(IconService);

  genderEnum = GenderEnum;
  menuTypeEnum = MenuTypeEnum;
  mainContactInvitationStatusEnum = MainContactInvitationStatusEnum;

  onClick() {
    this.childClick.emit(this.child);
    this.isChildMarked = !this.isChildMarked;
  }

  get secondaryClasses(): string {
    return `(${this.child.secondaryGroupNames.join(', ')})`;
  }
}
